<template>
    <main id="mainCtrl">
        <form style="height: calc(100vh - 95px); overflow-x: hidden;">
            <div style="height: 100%; overflow-x: hidden;">

                <div class="widgetTables">
                    <template v-for="(line, key) in lines">
                        <h4 @click="toggleVisibility(line, key)" style="cursor:pointer;">
                            <i class="fa fa-fw fa-chevron-down" v-if="line.active"></i>
                            <i class="fa fa-fw fa-chevron-right" v-else></i>
                            <b>{{line.title}}</b>
                        </h4>
                        <div v-if="line.active" style="margin-left: 24px;" :style="{'border-bottom': line.active ? 'solid 1px #c0c0c0' : 'none'}">
                            <div class="widget-img-box">
                                <a :href="fullUrl()" target="_blank">
                                    <img :src="'/img/widgets/'+ratingString()+'/' + line.size + '.png'" alt="">
                                </a>
                            </div>
                            <p>
                                Для размещения виджета скопируйте код ниже и добавьте на сайт клиники между тегами &lt;body&gt; ... &lt;/body&gt;
                            </p>

                            <div>
                                <div  class="widget-code-box" ref="code">
                                    <p>
                                        &lt;a href="{{fullUrl()}}"  target="_blank"&gt;
                                        <br>
                                        <span style="margin-left: 25px;" >&lt;img src="{{$parent.frontendUrl}}/clinic/image/widgets/{{clinic.url}}?size={{line.size}}" title="Рейтинг - {{clinic.name}}"&gt;</span>
                                        <br>
                                        &lt;/a&gt;
                                    </p>
                                </div>
                                <div class="widget-code-box-bottom">
                                    <button @click.prevent="copyCode()">Копировать</button>
                                    <p v-if="textVisible">Код скопирован!</p>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>

            </div>
        </form>
    </main>

</template>
<script>
export default {
    props:{
        clinic:{}
    },
    mounted() {

    },
    data(){
        return{
            lines: {
                0:{title:'Виджет 200x200', active:true, size:'200x200'},
                1:{title:'Виджет 240x400', active:false, size:'240x400'},
                2:{title:'Виджет 320x100', active:false, size:'320x100'},
            },
            textVisible: false

        }
    },
    methods:{
        toggleVisibility(line, key){
            this.lines[key].active = !this.lines[key].active

            for (const value in this.lines){
                if(value !== key && this.lines[value].active){
                    this.lines[value].active = false
                }
            }
            this.textVisible = false

        },
        ratingString(){
            if ((Math.round(this.clinic.rating * 5 * 10) / 10) < 3.5 || !this.clinic.ratingCommentCount) {
                return '0';
            }
            return (Math.round(this.clinic.rating * 5 * 10) / 10).toFixed(1).replace('.', ',')
        },
        fullUrl(){
            return "https://doctu.ru/"+ this.clinic.city +"/clinic/" + this.clinic.url.trim()
        },
        copyCode(){
            const sysInput = document.createElement('input')
            sysInput.setAttribute('value', this.$refs.code[0].innerText)
            document.body.appendChild(sysInput)
            sysInput.select()
            document.execCommand('copy');
            document.body.removeChild(sysInput)

            this.textVisible = true
        }
    }
}
</script>
<style>
.widgetTables{
    & button{
        margin: 20px 0;
    }
}
.widget-img-box{
    margin: 20px 0;
    & img{
        box-shadow: 0 1px 5px rgba(0, 0, 0, 0.25);
        border-radius: 8px;
    }
}
.widget-code-box{
    border: 1px solid rgb(192, 192, 192);
    padding: 15px;
    padding-bottom: 5px;
    box-shadow: inset 0 1px 5px rgba(0, 0, 0, 0.25);
    background-color: #f7f7f7;
    font-size: 14px;
    margin-top: 20px;
    font-family: Courier New;
}
.widget-code-box-bottom{
    display: flex;
    align-items: center;

    & p{
        margin: 0 20px;
        color: #00a65a;
        font-size: 14px;
    }
}
</style>
